import { Button, Tooltip } from '@fluentui/react-components';
import { bundleIcon, QuestionCircle20Filled, QuestionCircle20Regular } from '@fluentui/react-icons';
import { useTranslation } from 'react-i18next';
import { useIsFeatureEnabled } from '../../api/features/features';
import { useServiceDiscovery } from '../../hooks/useServiceDiscovery';
import { CALC_REVIEW_OVERVIEW_HELPID } from '../../utils/Urls.constant';

const QuestionCircleIconBundle = bundleIcon(QuestionCircle20Filled, QuestionCircle20Regular);

interface IHelpButtonProps {
    helpId?: string;
}

const HelpButton: React.FC<IHelpButtonProps> = ({ helpId = CALC_REVIEW_OVERVIEW_HELPID }: IHelpButtonProps) => {
    const { t } = useTranslation();
    const { helpUrl } = useServiceDiscovery();
    const { data: isHelpLinksIntegrationEnabled } = useIsFeatureEnabled({
        featureFlagName: 'HelpLinksIntegrationEnabled',
    });

    const openHelp = () => {
        window.open(`${helpUrl}&helpId=${helpId}`, '_blank');
    };

    return (
        <>
            {helpUrl && isHelpLinksIntegrationEnabled && (
                <Tooltip
                    content={t('corptaxHelp').toString()}
                    relationship='description'
                    positioning='below'
                    appearance='inverted'
                    withArrow
                >
                    <Button
                        appearance='subtle'
                        icon={<QuestionCircleIconBundle />}
                        aria-label={t('corptaxHelp').toString()}
                        data-testid='help-button'
                        onClick={openHelp}
                    />
                </Tooltip>
            )}
        </>
    );
};

export default HelpButton;
